import { render } from "./TermReport.vue?vue&type=template&id=354dfc7e"
import script from "./TermReport.vue?vue&type=script&lang=js"
export * from "./TermReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__